import React, { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";
import redirectURL from "../redirectURL";
import '../../assets/css/inventorymanagement.css';

const HistoricData = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [skuCode, setSkuCode] = useState(null);
  const [skuOptions, setSkuOptions] = useState([]);

  // Column Definitions
  const columnDefs = [
    { headerName: "Date", field: "date", sortable: true, filter: true, flex: 1, minWidth: 150 },
        { headerName: "Destination Store ID", field: "destination_store_id", sortable: true, filter: true, flex: 1, minWidth: 150 },
    { headerName: "Destination Store Name", field: "destination_store_name", sortable: true, filter: true, flex: 1, minWidth: 150 },
    { headerName: "Destination Store Type", field: "destination_store_type", sortable: true, filter: true, flex: 1, minWidth: 150 },

    { headerName: "Sale Order Number", field: "sale_order_number", sortable: true, filter: true, flex: 2, minWidth: 200 },
    { headerName: "Invoice ID", field: "invoice_id", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim Channel", field: "dim_channel", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim Sub Channel", field: "dim_subchannel", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim Party", field: "dim_party", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim Brand", field: "dim_brand", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim Category", field: "dim_category", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Client Product SKU", field: "client_product_sku", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim SKU", field: "dim_sku", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Dim SKU Name", field: "dim_sku_name", sortable: true, filter: true, flex: 3, minWidth: 250 },
    { headerName: "Dim SKU Code", field: "dim_sku_code", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Original Party Name", field: "original_party_name", sortable: true, filter: true, flex: 2, minWidth: 200 },
    { headerName: "Original SKU ID", field: "original_sku_id", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Original SKU Name", field: "original_sku_name", sortable: true, filter: true, flex: 3, minWidth: 300 },
    { headerName: "MRP", field: "mrp", sortable: true, filter: true, flex: 1, minWidth: 100, valueFormatter: formatCurrency },
    { headerName: "Source", field: "source", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Status", field: "status", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Pincode", field: "pincode", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Billing Party Code", field: "billing_party_code", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Customer Code", field: "customer_code", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Payment Method", field: "payment_method", sortable: true, filter: true, flex: 1, minWidth: 200 },
    { headerName: "Quantity", field: "qty", sortable: true, filter: true, flex: 1, minWidth: 200,filter: "agNumberColumnFilter",
 },
    { headerName: "GMV", field: "gmv", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Discount", field: "discount", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Tax", field: "tax", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Pre Tax NSR", field: "pre_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Post Tax NSR", field: "post_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Total Pre Tax NSR", field: "total_pre_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "RTO Pre Tax NSR", field: "rto_pre_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Cancelled Pre Tax NSR", field: "cancelled_pre_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Total Post Tax NSR", field: "total_post_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "RTO Post Tax NSR", field: "rto_post_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
    { headerName: "Cancelled Post Tax NSR", field: "cancelled_post_tax_nsr", sortable: true, filter: true, flex: 1, minWidth: 200, valueFormatter: formatCurrency },
  ];

  // Format currency values without symbol
  function formatCurrency(params) {
    if (params.value === undefined || params.value === null) return '';
    
    const formatter = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: false
    });
    
    return formatter.format(params.value);
  }

  // Default column definitions
  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  // Sidebar configuration
  const sideBar = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  };

  // Status panel configuration
  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  // Close alert
  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  // Fetch SKU codes for the filter
  const fetchSkuCodes = async () => {
    try {
      const response = await redirectURL.post("inventory/getHistoricSkuCodes", {});
      if (response.status === 200 && response.data.skuCodes) {
        const skuOptions = response.data.skuCodes.map(sku => ({ 
          value: sku, 
          label: sku 
        }));
        skuOptions.unshift({ label: "ALL", value: "" });
        setSkuOptions(skuOptions);
        setSkuCode(skuOptions[0]);
      }
    } catch (error) {
      console.error("Error fetching SKU codes:", error);
    }
  };

  // Get historic data with optional filters
  const getHistoricData = async (params = {}) => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      
      const response = await redirectURL.post("inventory/getOriginalHistoricSales", params);
      
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          
          // Set date range in state
          if (response.data.start_date && response.data.end_date) {
            const start = new Date(response.data.start_date).toISOString().split('T')[0];
            const end = new Date(response.data.end_date).toISOString().split('T')[0];
            setStartDate(start);
            setEndDate(end);
          }
          
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No historic data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching historic data:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch historic data");
      setBasicType("error");
      setShow(true);
    }
  };

  // Fetch data by date range and SKU code
  const getHistoricDataByFilters = async () => {
    try {
      if (!startDate || !endDate) {
        setBasicTitle("Please select both start and end dates");
        setBasicType("info");
        setShow(true);
        return;
      }

      setLoadshow("show-m");
      setOverlayBlock("show-m");
      
      const params = {
        start_date: startDate,
        end_date: endDate
      };

      // Add SKU code filter if selected
      if (skuCode && skuCode.value) {
        params.dim_sku_code = skuCode.value;
      }

      const response = await redirectURL.post("inventory/getOriginalHistoricSalesByFilters", params);
      
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No data found for the selected filters");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching historic data:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch historic data");
      setBasicType("error");
      setShow(true);
    }
  };

  // Reset to default (last 30 days)
  const resetToDefault = async () => {
    setSkuCode(skuOptions[0]); // Reset to "ALL"
    await getHistoricData();
  };

  // Initial load
  useEffect(() => {
    getHistoricData();
    fetchSkuCodes();
  }, []);

  // Select styles
  const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '1px',
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
      minHeight: '36px'
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 'normal',
      color: '#333',
      fontSize: '13px'
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '13px',
      fontWeight: state.isSelected ? 'normal' : 'normal',
    })
  };

  return (
    <>
      <div className="container-fluid mt-3">
        {/* Alert */}
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          {/* Filters */}
          <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-12 row">
              {/* Start Date */}
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Start Date:
                </label>
                <input
                  id="startDate"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('startDate')?.showPicker?.()}
                />
              </div>

              {/* End Date */}
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  End Date:
                </label>
                <input
                  id="endDate"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('endDate')?.showPicker?.()}
                />
              </div>

              {/* SKU Code Filter */}
              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="skuCode" style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                  id="skuCode"
                  value={skuCode}
                  onChange={setSkuCode}
                  options={skuOptions}
                  styles={selectStyles}
                  placeholder="Select SKU Code"
                />
              </div>

              {/* Action Buttons */}
              <div className="col-sm-4 mt-2" style={{ display: "flex", alignItems: "center", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); getHistoricDataByFilters(); }}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={(e) => { e.preventDefault(); resetToDefault(); }}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                // pagination={true}
                // paginationPageSize={100}
                enableRangeSelection={true}
                suppressHorizontalScroll={false}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Loader */}
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
    </>
  );
};

export default HistoricData;